///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roleselector = abcsetup.roleselector || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    $('#roles-modal').on('shown.bs.modal', function () {
        $("#roles-modal").find("#role-search").val('').focus().trigger('keyup');
    });

    // The search field had a key pressed
    $("#roles-modal").find("#role-search").on("keyup input", function(e) {
        const code = e.which;
        const value = $(this).val().toLowerCase();

        // Enter key is pressed
        if (code == 13 && value) {
            $('#roles-modal .modal-body .role-list a:visible:first').trigger('click');

        } else if (value) {
            // Remove all active links
            $('#roles-modal a.active').not('.selected').removeClass('active');

            // Filter down the sections + links to what was typed
            $("#roles-modal .role-list .section, #roles-modal .role-list a").filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });

            // Highlight the link
            $('#roles-modal .modal-body .role-list a:visible:first').addClass('active');

        } else {
            // Clear search results and show all links
            $('#roles-modal a.active').not('.selected').removeClass('active');
            $("#roles-modal .role-list .section, #roles-modal .role-list a, #roles-modal .role-list .form-group-header").show();
        }
    });

    // A link was clicked
    $(document).on('click', '#roles-modal a.list-group-item-action', function () {
        abcsetup.roleselector.selectRole($(this).data('value'));
        return false;
    });

    if (!abcsetup.guest && $('#tos.modal').length == 0) {
        // The users roles failed to load
        if (abcsetup.userRoles == null) {
            window.location.href = '/dashboard';
        }

        // The user only has 1 role, auto-set (if we haven't already)
        if (abcsetup.userRoles.length == 1 && !abcsetup.userRole) {
            abcsetup.roleselector.selectRole(abcsetup.userRoles[0].id);

        // Only show the role selector if the user has roles
        } else if (abcsetup.userRoles.length > 0) {
            abcsetup.roleselector.init();
        }
    }
});



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roleselector = {
    init: function () {
        let orgid = null;
        let html = '';
        let height = $(window).height() * .6; // Make the scrollable area 60% of the available screen

        // Dont show internal/hidden roles
        abcsetup.userRoles = $(abcsetup.userRoles).filter(function() {
            return !this.hidden;
        });

        // Load the roles into the role selector modal
        $(abcsetup.userRoles).each(function() {
            let active = '';

            // Build section and company header
            if (this.org && orgid != this.org.id) {
                if (orgid !== null) {
                    html = html + '</div>';
                }

                orgid = this.org.id;
                html = html + '<div class="section"><h4 class="form-group-header mt-3 mb-2">' + this.org.name + '</h4>';
            } else if (!this.org) {
                html = html + '<div class="section"><h4 class="form-group-header mt-3 mb-2"><i>No Supplier Name</i></h4>';
            }

            // The role is the current one
            if (abcsetup.userRole && abcsetup.userRole.id == this.id) {
                active = 'active selected';
            }

            let roleName = this.name ? this.name : this.role_class.name;
            roleName = roleName + (this.vendor_type ? ' - ' + this.vendor_type.toUpperCase() : '');
            roleName = roleName + (this.org ? ' (' + this.org.name + ')' : '');

            let delegated_to = this.delegate_to_user && (this.delegate_from_user == abcsetup.user.id) ? '<div class="delegated"><div><i class="fas fa-user-cog"></i> Delegated to ' + this.delegated_to_user.name + '</div></div>' : '';
            let delegated_from = this.delegate_from_user && (this.delegate_to_user == abcsetup.user.id) ? '<div class="delegated"><div><i class="fas fa-user-cog"></i> Delegated from ' + this.delegated_from_user.name + '</div></div>' : '';

            html = html + '<a href="#" class="px-3 list-group-item list-group-item-action flex-column align-items-start ' + active + '" data-value="' + this.id + '">\
                <div class="role_name delegate_status ">' + roleName + '</div>' +
                delegated_to + delegated_from + '\
            </a>';
        });

        // Show the roles and orgs
        $('#roles-modal .modal-body .role-list').html(html);

        // Apply slim scroll
        $('#roles-modal .modal-body .role-list').slimScroll({
            height: height + 'px',
            position: 'right',
            railVisible: true,
            alwaysVisible: false
        });

        // Show the model if we don't have a default role selected
        if (!abcsetup.userRole) {
            $("#roles-modal").find('.modal-footer, button, .btn').remove();
            $("#roles-modal").modal({backdrop: 'static', keyboard: false})
        }
    },


    /**
     *
     * @param {*} id
     */
    selectRole(id) {
        abcsetup.blockUI(true, true);
        $.get('/roles/set/' + id, function(data) {
            $('#roles-modal').modal('hide');

            abcsetup.blockUI(true, true);
            window.location.href = data.intended_url;
        });
    },
}
